import './parallax.scss';
import simpleParallax from 'simple-parallax-js';


const parallax = () => {
    var images = document.querySelectorAll('.parallax-block img');
    new simpleParallax(images, {
        scale: 1.5,
        // delay: .1,
        transition: 'ease-in'
    });
}

export default parallax;